import { TimeZoneDateFnsService } from 'app/core/services/time-zone-date-fns.service';
import { NotificationStatus } from 'app/shared/enums/notification-status.enum';
import { CustomDatePipe } from 'app/shared/pipes/custom-date.pipe';
import { ReadDocoonInboundFlowNotificationViewModel } from 'app/shared/prothesis-api-view-models/read-docoon-inbound-flow-notification.view-model';
import { buildNotificationCardTitle } from '../../build-notification-card-title';
import { DocoonInboundFlowNotificationCardModel } from './docoon-inbound-flow-notification-card.model';

export class DocoonInboundFlowNotificationModelHelper {
  public static fromViewModelSingle(
    readDocoonInboundFlowNotificationViewModel: ReadDocoonInboundFlowNotificationViewModel,
    customDatePipe: CustomDatePipe,
  ): DocoonInboundFlowNotificationCardModel {
    const docoonInboundFlowNotificationCard = new DocoonInboundFlowNotificationCardModel();
    docoonInboundFlowNotificationCard.colorClass = 'notification-primary';
    docoonInboundFlowNotificationCard.discriminator = readDocoonInboundFlowNotificationViewModel.discriminator;
    docoonInboundFlowNotificationCard.notificationDate = TimeZoneDateFnsService.toLaboratoryTimeZone(
      readDocoonInboundFlowNotificationViewModel.notificationDate,
    );
    docoonInboundFlowNotificationCard.readDate = TimeZoneDateFnsService.toLaboratoryTimeZone(
      readDocoonInboundFlowNotificationViewModel.readDate,
    );
    docoonInboundFlowNotificationCard.title = buildNotificationCardTitle(
      "Factures d'achat",
      readDocoonInboundFlowNotificationViewModel.notificationDate,
      customDatePipe,
    );

    docoonInboundFlowNotificationCard.messageLine1 = "Factures d'achat";

    // The uuids are only filled once the check succeeded; a pending, failed or empty check carries none, and the
    // card keeps its empty lists.
    if (readDocoonInboundFlowNotificationViewModel.purchaseCreditUuids) {
      docoonInboundFlowNotificationCard.purchaseCreditUuids = readDocoonInboundFlowNotificationViewModel.purchaseCreditUuids;
    }
    if (readDocoonInboundFlowNotificationViewModel.purchaseInvoiceUuids) {
      docoonInboundFlowNotificationCard.purchaseInvoiceUuids = readDocoonInboundFlowNotificationViewModel.purchaseInvoiceUuids;
    }

    docoonInboundFlowNotificationCard.newDocumentExistenceFlag =
      docoonInboundFlowNotificationCard.purchaseCreditUuids.length > 0 || docoonInboundFlowNotificationCard.purchaseInvoiceUuids.length > 0;

    docoonInboundFlowNotificationCard.statusFailedFlag = readDocoonInboundFlowNotificationViewModel.status === NotificationStatus.Failed;
    docoonInboundFlowNotificationCard.statusNothingToDoFlag =
      readDocoonInboundFlowNotificationViewModel.status === NotificationStatus.NothingToDo;
    docoonInboundFlowNotificationCard.statusPendingFlag = readDocoonInboundFlowNotificationViewModel.status === NotificationStatus.Pending;
    docoonInboundFlowNotificationCard.statusSucceedFlag = readDocoonInboundFlowNotificationViewModel.status === NotificationStatus.Succeed;

    docoonInboundFlowNotificationCard.uuid = readDocoonInboundFlowNotificationViewModel.uuid;
    return docoonInboundFlowNotificationCard;
  }
}
